export const findWalks_sv = {
  'create_a_walk' : 'Skapa en promenad',
  'all_filtered_booked' : 'Alla promenader som matchade ditt filter är bokade.',
  'no_walks_found' : 'Kunde inte hitta några promenader som matchade ditt filter.',

  'filter_walks' : 'Filtrera promenader',
  'filter_where_label' : 'Var vill du promenera?',
  'filter_where_placeholder' : 'Fyll i plats',
  'filter_where_position' : 'Använd min position',
  'filter_radius_label' : 'Välj din sökradie',
  'filter_radius_placeholder' : 'Km från plats',
  'filter_radius_help' : 'Standard: 10 km',
  'filter_when_label' : 'När vill du promenera?',
  'filter_when_placeholder' : 'Välj tid',
  'filter_day_label' : 'Vilken dag vill du promenera?',
  'filter_day_placeholder' : 'Välj dag',
  'filter_button_text' : 'Filterera promenader',
  'filter_error_choose' : 'Välj ett eller flera filter för att filtrera.',
  'clear_choice' : 'Rensa val',
  'clear_filter' : 'Rensa filter',
  'my_position' : 'Min position',
  'spot' : 'plats',
  'spots' : 'platser',

  'find_walks_error_header' : 'Kunde inte hämta din position',
  'find_walks_error_message' : 'För att visa promenader nära dig måste du tillåta geolocation.',
  'no_reviews' : 'Inga omdömen än',

  'place_error' : 'Kunde inte hitta platsen, var vänlig kontrollera ditt filter',
  'position_error' : 'Kunde inte hitta din position, men du kan fylla i din plats manuellt',
  'map_gps_error_header' : 'Kunde inte visa promenader nära dig.',
  'map_gps_error_message' : 'För att visa promenader nära dig måste du tillåta geolocation'
}